import { isSimpleMiningUrl } from 'utils/isSimpleMiningUrl';

const simplePodNavLinks = [
  {
    name: 'changelog.navigationTitle.allChanges',
    path: '/changelog',
  },
  {
    name: 'changelog.navigationTitle.instances',
    path: '/changelog/instance',
  },
  {
    name: 'changelog.navigationTitle.hosts',
    path: '/changelog/host',
  },
];

const simpleMiningNavLinks = [
  { name: 'changelog.navigationTitle.allChanges', path: '/changelog' },
  {
    name: 'changelog.navigationTitle.dashboard',
    path: '/changelog/dashboard',
  },
  { name: 'changelog.navigationTitle.rigUpdates', path: '/changelog/rig' },
  { name: 'changelog.navigationTitle.osImages', path: '/changelog/os' },
  { name: 'changelog.navigationTitle.miners', path: '/changelog/miner' },
];

export const navLinks = isSimpleMiningUrl()
  ? simpleMiningNavLinks
  : simplePodNavLinks;
